import HTTP from '../../../../api/AxiosConfig';

export const getDayMenu = (dayNumber) =>
    HTTP.get('/menu/update?dayNumber=' + dayNumber).finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const getFoodMenu = () =>
    HTTP.get('/menu').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );

export const saveMenuDay = (dayMenu) =>
    HTTP.post('/menu/save', dayMenu);

export const updatePredictedPeoples = (people) =>
    HTTP.post('/menu/predict-people', people);

export const getProductsShortage = () =>
    HTTP.get('/menu/shortage').finally(
        (response) =>
            new Promise((resolve) => {
                resolve(response);
            }),
    );
